import { Link } from "react-router-dom";
import { Flame, ArrowLeft } from "lucide-react";
import { ReactNode } from "react";

interface Props {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}

export default function LegalLayout({ title, lastUpdated, children }: Props) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary">
              <Flame className="h-4 w-4 text-primary-foreground" />
            </div>
            <span className="font-semibold text-foreground">LegacyGrowth Engine</span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
          >
            <ArrowLeft className="h-4 w-4" /> Back home
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-6 py-12">
        <h1 className="mb-2 text-3xl font-bold text-foreground">{title}</h1>
        <p className="mb-8 text-sm text-muted-foreground">Last updated: {lastUpdated}</p>
        <article className="prose prose-sm max-w-none text-foreground [&_h2]:mt-8 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-foreground [&_h3]:mt-6 [&_h3]:text-base [&_h3]:font-semibold [&_p]:my-3 [&_p]:leading-relaxed [&_p]:text-muted-foreground [&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:text-muted-foreground [&_li]:my-1 [&_a]:text-primary [&_a]:underline">
          {children}
        </article>
        <footer className="mt-16 border-t border-border pt-6 text-center text-xs text-muted-foreground">
          <div className="flex justify-center gap-6">
            <Link to="/privacy" className="hover:text-foreground">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-foreground">Terms of Service</Link>
            <Link to="/hipaa" className="hover:text-foreground">HIPAA Notice</Link>
          </div>
          <p className="mt-3">© {new Date().getFullYear()} H&amp;E Associates LLC. All rights reserved.</p>
        </footer>
      </main>
    </div>
  );
}